import { DesignData, Page } from 'src/store/design/types';

enum DesignPageMediaItemType {
  TEXT = 'text',
  IMAGE = 'image',
  ADDON = 'addon',
  LINE = 'line',
  RECTANGLE = 'rectangle',
}

const NOT_EMPTY_TYPES = new Set([
  DesignPageMediaItemType.TEXT,
  DesignPageMediaItemType.LINE,
  DesignPageMediaItemType.RECTANGLE,
  DesignPageMediaItemType.IMAGE,
  DesignPageMediaItemType.ADDON,
]);

/**
 * Checks if a page has content (is not empty)
 *
 * @param page - The page to check
 * @returns true if the page has content, false otherwise
 */
const isUsedPage = (page: Page): boolean => {
  if (!page?.groups?.media?.length) {
    return false;
  }

  return !page.groups.media.every((element) => {
    if (element.type === DesignPageMediaItemType.IMAGE) {
      return !element.imageId;
    }

    return !NOT_EMPTY_TYPES.has(element.type as DesignPageMediaItemType);
  });
};

/**
 * Gets the names of spreads that have content (non-empty media elements)
 *
 * @param designData - The design structure to analyze
 * @returns Set of spread names that contain content
 */
const getUsedSpreads = (designData?: DesignData): Set<string> => {
  const usedSpreads = new Set<string>();

  if (!designData) {
    return usedSpreads;
  }

  designData.spreads.forEach((spread) => {
    // Check if any page in this spread has content
    const hasContent = spread.pages.some((page) => isUsedPage(page));

    if (hasContent) {
      usedSpreads.add(spread.name);
    }
  });

  return usedSpreads;
};

export default getUsedSpreads;
